import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { Row as LayoutRow } from 'shared/components/birch/row';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import CandidateChips from 'talent_matching/components/shared/candidate_chips';
import SocialLinks from 'talent_matching/components/shared/social_links';
import { RejectModalProvider } from 'application_review/components/reject_modal_context';
import {
  type BaseCandidate,
  type Row,
  type Paths,
} from 'talent_matching/types';
import noop from 'lodash/noop';

type Props = {
  candidate: BaseCandidate;
  onRejectSuccess?: (row: Row, closeModal: () => void) => void;
  paths?: Paths;
  canAdvance?: boolean;
  canReject?: boolean;
  canDownloadCandidateData?: boolean;
  nameAdornment?: React.ReactNode;
  children?: React.ReactNode;
};

const BaseCandidateCell = ({
  candidate,
  onRejectSuccess = noop,
  paths,
  canAdvance,
  canReject,
  canDownloadCandidateData,
  nameAdornment,
  children,
}: Props) => {
  return (
    <Stack
      spacing={1}
      alignContent="flex-start"
      sx={{
        padding: 1,
        paddingLeft: 0,
        height: '100%',
      }}
    >
      <LayoutRow spacing={0.5}>
        <SecondaryBody medium className="candidate-full-name pii-blur">
          {candidate.fullName}
        </SecondaryBody>
        {nameAdornment}
      </LayoutRow>
      {children}
      <CandidateChips application={candidate} />
      <RejectModalProvider>
        <SocialLinks
          application={candidate}
          onRejectSuccess={onRejectSuccess}
          paths={paths}
          canAdvance={canAdvance}
          canReject={canReject}
          canDownloadCandidateData={canDownloadCandidateData}
        />
      </RejectModalProvider>
    </Stack>
  );
};

export default BaseCandidateCell;
